import { Typography } from "@mui/material";
import { memo } from "react";

import type { FloatingLabelProps } from "./FloatingLabel.types";
import * as styles from "./FloatingLabel.styles";

export type { FloatingLabelProps } from "./FloatingLabel.types";

export const FloatingLabel = memo(function FloatingLabel({
  label,
  htmlFor,
  size = "md",
}: FloatingLabelProps) {
  return (
    <Typography component="label" htmlFor={htmlFor} variant="caption" sx={styles.root(size)}>
      {label}
    </Typography>
  );
});
